import { TmAuthError } from '@/core/error/transport/auth/TmAuthError'
import type { Optional } from '@/types'

export class TmAuthNeedVerifyEmailError extends TmAuthError {
  public get userId(): Optional<string> {
    return this.data?.data?.userId ? `${this.data.data.userId}` : undefined
  }
}
